import React, { useState, useEffect, useCallback } from "react";
import { useLoading } from "../../../../../context/LoadingContext";
import DataTable from "../../../../Requirement/components/common/ReusableTable";
import {
  fetchData,
  searchfetchQueries,
  postQuery,
  formatData,
} from "../../../../../services/BackendServices";
import dayjs from "dayjs";
import SearchFilter from "../../../../Requirement/components/common/SearchFilter";
import OfferDetails from "../../../requirement/component/OfferDetails";
import AlertModal from "../../../../Requirement/components/common/AlerModel";
import TrustScoreModal from "../../../../../components/common/TrustScoreModal";

const BuyerActivityMatchingOffers = ({
  requirementDetails,
  activeUser,
  onResponse,
}) => {
  const { setLoading } = useLoading();
  const [offerList, setOfferList] = useState([]);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [productList, setProductList] = useState([]);
  const [productGradeList, setProductGradeList] = useState([]);
  const [rowStart, setRowStart] = useState(0);
  const [pageSize] = useState(5);
  const [totalItems, setTotalItems] = useState(0);
  const [productDetails, setProductDetails] = useState({});
  const [INRToUsd] = useState(0.012);
  const [searchValues, setSearchValues] = useState({
    searchOfferProduct: "",
    searchOfferProductGrade: "",
    searchPriceRange: "",
  });

  const priceOptions = [
    { value: "", label: "Select Range" },
    { value: "0-1000", label: "0-1000 USD" },
    { value: "1000-2000", label: "1000-2000 USD" },
    { value: "2000-5000", label: "2000-5000 USD" },
    { value: "Above-5000", label: "Above 5000 USD" },
  ];

  const [modal, setModal] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
    nextAction: null,
    autoClose: null,
  });

  const handleModalClose = () => {
    const action = modal.nextAction;
    setModal((prev) => ({ ...prev, show: false, nextAction: null }));
    if (action) action();
  };

  // State for Verification Status Modal
  const [trustModal, setTrustModal] = useState(false);

  const trustModel = useCallback(() => {
    setTrustModal(true);
  }, []);

  const loadProductList = useCallback(async () => {
    try {
      const [initialResponse] = await Promise.all([
        fetchData({
          target: "listProducts",
          userOrder: "ProductName",
          rowStart: 0,
          pageSize: 1,
          filterTerms: { Status: "ACTIVE" },
        }),
      ]);

      const totalCount = initialResponse?.total || initialResponse?.length || 0;

      if (totalCount > 0) {
        const [allProducts] = await Promise.all([
          searchfetchQueries({
            target: "listProducts",
            userOrder: "ProductName",
            rowStart: 0,
            pageSize: totalCount,
            filterTerms: { Status: "ACTIVE" },
          }),
        ]);

        const distinctProducts = Array.from(
          new Map(allProducts.map((p) => [p.ProductName, p])).values()
        );
        setProductList(distinctProducts);
      } else {
        setProductList([]);
      }
    } catch (error) {
      console.error("Error loading products: ", error);
    }
  }, []);

  const loadProductGrades = useCallback(async (productName) => {
    try {
      const [allGrades] = await Promise.all([
        fetchData({
          target: "listProducts",
          userOrder: "ProductName",
          rowStart: 0,
          pageSize: 500,
          filterTerms: { ProductName: productName },
        }),
      ]);
      if (allGrades.items.length > 0) {
        setProductGradeList(allGrades.items);
      } else {
        setProductGradeList([]);
      }
    } catch (error) {
      console.error("Error loading product grades: ", error);
    }
  }, []);

  const getProductDetails = useCallback(async (productId) => {
    try {
      const response = await fetchData({
        target: "listProducts",
        userOrder: "ProductID",
        rowStart: 0,
        pageSize: 1,
        filterTerms: { ProductID: productId },
      });

      if (response.items && response.items.length > 0) {
        const product = response.items[0];
        setProductDetails({
          ProductName: product.ProductName,
          Grade: product.Grade,
        });
      }
    } catch (error) {
      console.error("Error fetching product details:", error);
      setProductDetails({});
    }
  }, []);

  const formatDate = useCallback((dateString) => {
    if (!dateString) return "";
    try {
      return dayjs(dateString).format("DD-MM-YYYY");
    } catch (error) {
      console.error("Error formatting date:", error);
      return "";
    }
  }, []);

  const fetchMatchingOffers = useCallback(
    async (searchValues, newRowStart = rowStart) => {
      if (!requirementDetails) return;
      setSelectedOffer(null);
      setLoading(true);
      try {
        let priceFilter = {};
        if (searchValues.searchPriceRange) {
          if (searchValues.searchPriceRange === "Above-5000") {
            priceFilter = { CIFSalePriceGTE: 5000 };
          } else {
            const searchPrice = searchValues.searchPriceRange;
            const [min, max] = searchPrice
              .split("-")
              .map((val) => parseFloat(val));
            priceFilter = {
              CIFSalePriceGTE: min,
              CIFSalePriceLTE: max,
            };
          }
        }

        const quantity =
          parseFloat(requirementDetails.Quantity) ||
          parseFloat(requirementDetails.RequestedQuantity) ||
          0;
        const quantityRange = Math.max(50, quantity * 0.05);
        const destinationCountry = requirementDetails.DeliveryLocation
          ? requirementDetails.DeliveryLocation.split("~")[0] || ""
          : "";

        console.log("productDetails@@", productDetails);

        const body = {
          // target: "listBuyerItemDetails",
          target: "listBuyerItemRFQDetails",
          userOrder: "CreatedAt DESC",
          rowStart: newRowStart,
          pageSize: pageSize,
          filterTerms: {
            GPEmailID: activeUser,
            BuyerEmailID: requirementDetails.CreatedByEmailID,
            //product: productDetails.ProductName,
            //grade: productDetails.Grade,
            GPOOfferStatus: "Indicative",
            ProductID: requirementDetails.ProductID,
            DestinationCountry: destinationCountry,
            OriginCountry: requirementDetails.OriginCountry || "",
            QuantityGT: quantity - quantityRange,
            QuantityLT: quantity + quantityRange,
            ...priceFilter,
          },
        };

        const response = await fetchData(body);
        if (Array.isArray(response.items) || Array.isArray(response)) {
          const items = response.items || response || [];
          // Ensure each item has IsShortlist property
          const itemsWithShortlist = items.map((item) => ({
            ...item,
            IsShortlist:
              item.IsShortlist !== undefined ? item.IsShortlist : false,
          }));
          setOfferList(itemsWithShortlist);
          setTotalItems(response.total || 0);
        } else {
          throw new Error("Unexpected response format");
        }
      } catch (error) {
        console.error("Error loading matching offers:", error);
        setOfferList([]);
        setTotalItems(0);
      } finally {
        setLoading(false);
      }
    },
    [pageSize, rowStart, setLoading, requirementDetails, productDetails]
  );

  const handleSearch = (searchValues) => {
    setRowStart(0);
    fetchMatchingOffers(searchValues, 0);
  };

  const handlePageChange = (page) => {
    const newRowStart = (page - 1) * pageSize;
    setRowStart(newRowStart);
    fetchMatchingOffers(searchValues, newRowStart);
  };

  const handleRowClick = (row, event) => {
    console.log("Offer row clicked:", row);
    console.log("Row structure:", Object.keys(row));
    setSelectedOffer(row);
  };

  const handleOfferResponse = () => {
    console.log("Offer response handled");
    setSelectedOffer(null);
    onResponse();
  };

  const Button = ({ label, onClick }) => {
    return (
      <button
        className="btn-action-re"
        onClick={onClick}
        style={{ width: "140px" }}
      >
        {label}
      </button>
    );
  };

  const sendTrueToParent = () => {
    console.log("child sendTrueParent");
    onResponse(true); // Sends true to parent via callback
  };

  const handleShortlist = async (offer) => {
    setLoading(true);
    console.log("handleShortlist triggered");
    console.log("shortlistOffer::", offer);
    try {
      // Simulate API call with a 1-second delay
      let body = null;
      console.log("Saving data to API:", offer);

      body = {
        target: "gpShortlistOffer",
        GPOfferExtendedInput: {
          GPOfferID: offer.GPOfferID,
          OfferStatus: "Shortlist",
          Margin: offer.Margin,
          CategoryType: "rfq",
          GPEmailID: activeUser,
          RequirementsID: requirementDetails.RequirementsID,
        },
      };

      console.log("Saving body to API:", body);
      if (body !== null) {
        const result = await postQuery(body, "backendops");
        console.log("result@", result);
        if (result) {
          setModal({
            show: true,
            type: "success",
            title: "Success",
            message: `Offer shortlisted successfully!`,
            autoClose: false,
            nextAction: () => {
              sendTrueToParent();
              setSelectedOffer(null);
            },
          });
        }
      }

      // Refresh the table data
      await fetchMatchingOffers(searchValues, rowStart);
    } catch (error) {
      console.error("Error saving data:", error);
      setModal({
        show: true,
        type: "error",
        title: "Error",
        message: "Failed to shortlist offer. Please try again.",
        autoClose: false,
      });
    } finally {
      setLoading(false);
    }
  };

  const currentPage = Math.floor(rowStart / pageSize) + 1;

  const fields = [
    {
      name: "searchOfferProduct",
      label: "Product",
      type: "dropdown",
      options: productList.map((item) => ({
        value: item.ProductName,
        label: item.ProductName,
      })),
      value: searchValues.searchOfferProduct,
      onChange: (value) => {
        setSearchValues((prev) => ({ ...prev, searchOfferProduct: value }));
        loadProductGrades(value);
      },
    },
    {
      name: "searchOfferProductGrade",
      label: "Product Grade",
      type: "dropdown",
      options: productGradeList.map((item) => ({
        value: item.Grade,
        label: item.Grade,
      })),
      value: searchValues.searchOfferProductGrade,
      onChange: (value) => {
        setSearchValues((prev) => ({
          ...prev,
          searchOfferProductGrade: value,
        }));
      },
    },
    {
      name: "searchPriceRange",
      label: "Price Range (USD)",
      type: "dropdown",
      options: priceOptions,
      value: searchValues.searchPriceRange,
      onChange: (value) => {
        setSearchValues((prev) => ({ ...prev, searchPriceRange: value }));
        fetchMatchingOffers({ ...searchValues, searchPriceRange: value }, 0);
      },
    },
  ];

  const columns = [
    { id: "OfferNumber", numeric: false, label: "Offer No." },
    { id: "ProductName", numeric: false, label: "Product" },
    { id: "Grade", numeric: false, label: "Grade" },
    {
      id: "Quantity",
      numeric: true,
      label: "Quantity (MT)",
      renderCell: (row) => row.Quantity,
    },
    {
      id: "FOBSalePrice",
      numeric: true,
      label: "FOB Sale Price (USD)",
      renderCell: (row) => formatData(row.FOBSalePrice),
    },
    { id: "Country", numeric: false, label: "Origin Country" },
    { id: "DestinationCountry", numeric: false, label: "Destination" },
    { id: "INCO", numeric: false, label: "INCO Terms" },
    {
      id: "GPOOfferStatus",
      numeric: false,
      label: "Offer Status",
      renderCell: (row) => {
        let bgColor = "";
        let textColor = "";

        switch (row.GPOOfferStatus) {
          case "BAFO":
            bgColor = "#e0f2fe";
            textColor = "#0369a1";
            break;
          case "Firmoffer":
            bgColor = "#d1fae5";
            textColor = "#065f46";
            break;
          default:
            bgColor = "#fef3c7";
            textColor = "#b45309";
            // row.OfferStatus = "Indicative"; // Set default status
            break;
        }

        return (
          <span
            style={{
              backgroundColor: bgColor,
              color: textColor,
              padding: "4px 10px",
              borderRadius: "999px",
              fontSize: "0.75rem",
              fontWeight: 500,
            }}
          >
            {row.GPOOfferStatus}
          </span>
        );
      },
    },
    {
      id: "CreatedAt",
      numeric: false,
      label: "Created Date",
      renderCell: (row) => formatDate(row.CreatedAt),
    },
    {
      id: "Expires",
      numeric: false,
      label: "Expires",
      renderCell: (row) => formatDate(row.Expires),
    },
    {
      id: "KYBStatus",
      numeric: false,
      label: "Seller Status",
      renderCell: (row) => {
        let bgColor = "";
        let textColor = "";

        switch (row.KYBStatus) {
          case "Approved":
            bgColor = "#d1fae5";
            textColor = "#065f46";
            break;
          default:
            bgColor = "#fef3c7";
            textColor = "#b45309";
        }

        return (
          <span
            style={{
              backgroundColor: bgColor,
              color: textColor,
              padding: "4px 10px",
              borderRadius: "999px",
              fontSize: "0.75rem",
              fontWeight: 500,
              display: "inline-block",
            }}
          >
            {row.KYBStatus === "Approved" ? "Verified" : "Unverified"}
          </span>
        );
      },
    },
  ];

  useEffect(() => {
    if (requirementDetails) {
      //getProductDetails(requirementDetails.ProductID);
      loadProductList();
    }
  }, [requirementDetails, getProductDetails, loadProductList]);

  useEffect(() => {
    if (requirementDetails && productList.length > 0) {
      fetchMatchingOffers(searchValues);
    }
  }, [
    rowStart,
    pageSize,
    requirementDetails,
    fetchMatchingOffers,
    searchValues,
    productList,
  ]);

  return (
    <div>
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        buttonText="OK"
        autoClose={modal.autoClose}
      />
      <div className="search-filter4">
        <div className="title4">
          <div className="head-text">Matching Offers</div>
        </div>
        <div className="filter4">
          <SearchFilter fields={fields} onSearch={handleSearch} />
        </div>
      </div>

      <DataTable
        columns={columns}
        data={offerList}
        total={totalItems}
        title="Matching Offers"
        rowsPerPage={pageSize}
        onPageChange={handlePageChange}
        currentPage={currentPage}
        onRowClick={handleRowClick}
        selectedRows={selectedOffer ? [selectedOffer.GPOfferID] : []}
      />
      {selectedOffer && (
        <div className="offer-detail1">
          <div className="header-text-re">
            <div className="head-text">Offer Details</div>
            {selectedOffer ? (
              selectedOffer.BuyerExtendedStatus === "Shortlist" ? (
                <>
                  <Button label="Verification Status" onClick={trustModel} />
                  <div className="submit-btn-more">Shortlisted</div>
                </>
              ) : selectedOffer.BuyerExtendedStatus === "Firmoffer" ? (
                <>
                  <Button label="Verification Status" onClick={trustModel} />
                  <div className="submit-btn-more">Send Firm Offer</div>
                </>
              ) : (
                <div className="button-group">
                  <Button label="Verification Status" onClick={trustModel} />
                  {/* <Button
                    label="Shortlist"
                    onClick={() => handleShortlist(selectedOffer)}
                  />
                  <Button label="Send Firm Offer" />
                  <Button label="Ask seller a question" /> */}
                </div>
              )
            ) : (
              <div></div>
            )}
          </div>

          <OfferDetails
            offer={selectedOffer}
            btnShortlist={false}
            btnSendQuery={false}
            btnRequestQuote={false}
            btnRequestSpecifications={false}
            btnRequestBestPrice={false}
            btnNegotiate={false}
            btnRequestShippingDetails={false}
            btnLogisticsSupport={false}
            INRToUsd={INRToUsd}
            activeUser={activeUser}
            requirementDetails={requirementDetails}
            onResponse={handleOfferResponse}
          />
        </div>
      )}
      {/* Verification Status Modal */}
      {trustModal && selectedOffer && (
        <TrustScoreModal
          onClose={() => setTrustModal(false)}
          userEmail={selectedOffer.SellerEmailID}
        />
      )}
    </div>
  );
};

export default BuyerActivityMatchingOffers;
